<template>
    <b-list-group class="block__commercialResume">
      <b-list-group-item v-for="(list,index) in lists" :key="index" style="cursor: pointer" :class="list.progression === '+' ? 'positif' : 'negatif'" v-on:click="$router.push('/commerciaux/commercial/' + list.id)">
        <div class="fullname">
          <PuSkeleton :loading="isLoading" :count="1" height="20px">                                        
            {{list.fullName}}
          </PuSkeleton>
        </div>
        <div class="right d-none">
          <PuSkeleton :loading="isLoading" :count="1" height="20px" width="20px" >
            <span>
              <font-awesome-icon v-if="list.progression === '+'" :icon="['far', 'chart-line']" />
              <font-awesome-icon v-if="list.progression === '-'" :icon="['far', 'chart-line-down']" />
            </span>

            <div class="number">{{Math.round(list.number)}}%</div>
          </PuSkeleton>
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="lists == null || lists.length === 0">
        <div class="fullname">
          <PuSkeleton :loading="isLoading" :count="1" height="20px">
            Aucun commerciaux enregistré
          </PuSkeleton>
        </div>
        <div class="right d-none">
          <PuSkeleton :loading="isLoading" :count="1" height="20px" width="20px">

          </PuSkeleton>
        </div>
      </b-list-group-item>
    </b-list-group>
</template>


<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../services/ApiService'

//
export default {
  name: "ListCommercialResume",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getListsCommercialResume'
      ])
    },  
  props:{
    // lists:{
    //   type:Object
    // }
  },
  methods:{
    async getData(){
      await ApiService.getParcourirApi().getFavoritesCommercials().then((data) => {
        this.lists = [];
        for (const listByType of Object.values(data.data)) {
          this.lists = [...this.lists, ...listByType]
        }
      });
    }
  },
  data(){
    return { 
      lists:"",
      isLoading:true,
    }
  },
  created (){
    this.isLoading = true;
    this.getData().then(() => this.isLoading = false);
  }
}
</script>
